import { MODAL_ID_DEFAULT } from '../../../constants/common'
import { MINIMIZED_MODAL_KEY } from '../../Modal'
import { TaskTableCellName } from '../../Task'

export const QA_NAME_REQUEST_PROFILE_OPEN_ACTIVITIES =
  'requestProfileOpenActivities'

export const REQUEST_PROFILE_OPEN_ACTIVITIES_DRAFT_PREFIX = 'open-activities'

export const REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_EDIT = 'open_activity_edit'

export const REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_ATTACH_FROM_DOCUMENT_STORAGE =
  'open_activity_attach_from_document_storage'

export const REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_ATTACH_FROM_REQUEST_FOLDER =
  'open_activity_attach_from_request_folder'

export const REQUEST_PROFILE_OPEN_ACTIVITIES_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
}

export const QA_NAME_REQUEST_PROFILE_OPEN_ACTIVITIES_TABLE =
  'requestProfileOpenActivitiesTable'

export const QA_NAME_REQUEST_PROFILE_OPEN_ACTIVITIES_SHOW_MORE =
  'requestProfileOpenActivitiesShowMore'

export const REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE = 10

export const REQUEST_PROFILE_OPEN_ACTIVITIES_ORDERING = [
  'phase_position',
  'position',
]

export const REQUEST_PROFILE_OPEN_ACTIVITIES_STATUS = 'open'

export const REQUEST_PROFILE_OPEN_ACTIVITIES_SKELETON_ROWS_COUNT = 10

export const REQUEST_PROFILE_OPEN_ACTIVITIES_SKELETON_ROW_TITLE_WIDTHS = [
  '88%',
  '72%',
  '94%',
  '65%',
  '80%',
  '70%',
  '90%',
  '60%',
  '84%',
  '76%',
]

export const REQUEST_PROFILE_OPEN_ACTIVITIES_TABLE_COLUMNS_CONFIG = {
  [TaskTableCellName.Deadline]: {
    index: 5,
    name: TaskTableCellName.Deadline,
    ordering_field: null,
    title: 'ActivityTable.DeadlineColumnTitleKey',
    visible: true,
    width: 192,
  },
  [TaskTableCellName.Manager]: {
    index: 3,
    name: TaskTableCellName.Manager,
    ordering_field: null,
    title: 'ActivityTable.ManagerColumnTitleKey',
    visible: true,
    width: 74,
  },
  [TaskTableCellName.Phase]: {
    index: 2,
    name: TaskTableCellName.Phase,
    ordering_field: null,
    title: 'ActivityTable.PhaseColumnTitleKey',
    visible: true,
    width: 192,
  },
  [TaskTableCellName.Priority]: {
    index: 6,
    name: TaskTableCellName.Priority,
    ordering_field: null,
    title: 'ActivityTable.PriorityColumnTitleKey',
    visible: true,
    width: 120,
  },
  [TaskTableCellName.Status]: {
    index: 0,
    name: TaskTableCellName.Status,
    ordering_field: null,
    title: 'ActivityTable.StatusColumnTitleKey',
    visible: true,
    width: 130,
  },
  [TaskTableCellName.Title]: {
    index: 1,
    name: TaskTableCellName.Title,
    ordering_field: null,
    title: 'ActivityTable.TitleColumnTitleKey',
    visible: true,
  },
  [TaskTableCellName.VisibleToTenant]: {
    index: 4,
    name: TaskTableCellName.VisibleToTenant,
    ordering_field: null,
    title: 'ActivityTable.VisibleToTenantColumnTitleKey',
    visible: true,
    width: 56,
  },
}
